export const CopyEffect2 = () => {
    return (
        <div className="container">
            <h2>効果コピー</h2>
            <p>現在は使用できません
           </p>
        </div>
    )
}